export const myDocumentsTranslationsHu = {
  MY_DOCUMENTS_USER_FILES_PAGE_TITLE: "Dolgozói dokumentumok áttekintése, kezelése",
  MY_DOCUMENTS_UPLOAD_PAGE_TITLE: "Dokumentumok feltöltése",
  MY_DOCUMENTS_MISSING_UPLOADERS: "Nincs beállított feltöltő",
  MY_DOCUMENTS_DELETE_CONFIRM_INFO: "Valóban törli a dokumentumot?",
  MY_DOCUMENTS_OPERATOR_GUIDE: "MyDocuments kezelői kézikönyv",
  MY_DOCUMENTS_USER_GUIDE: "MyDocuments felhasználói kézikönyv",
  MY_DOCUMENTS_VIEWING_DOCUMENTS: "Dokumentumok megtekintése",
  MY_DOCUMENTS_MANAGING_DOCUMENTS: "Dokumentumok kezelése",
  MY_DOCUMENTS_DOCUMENT_NOT_FOUND: "Nincs feltöltött dokumentum!",
  MY_DOCUMENTS_DOCUMENT_ERROR_DELETION: "Dokumentum törlése sikertelen",
  MY_DOCUMENTS_DOCUMENT_SUCCESSFUL_DELETION: "Dokumentum törlése sikeresen megtörtént",
  MY_DOCUMENTS_EDIT_DOCUMENT: "Dokumentum szerkesztése",
  MY_DOCUMENTS_DOCUMENT_UPLOAD_SUCCESSFUL: "A fájl feltöltése sikeresen megtörtént",
  MY_DOCUMENTS_DOCUMENT_UPLOAD_FAILED: "A fájl feltöltése nem sikerült",
  MY_DOCUMENTS_UPLOAD_DOCUMENT: "Dokumentum feltöltése",
  MY_DOCUMENTS_MENU_ALLOWED_INFO: "Minden felhasználó számára elérhetővé válik a MyHR menüben a Dokumentumok menüpont",
  MY_DOCUMENTS_NEW_DOCUMENTS: "Új dokumentum",
  MY_DOCUMENTS_UPLOADERS: "Feltöltő(k)",
  MY_DOCUMENTS_UPLOADER: "Feltöltő",
  MY_DOCUMENTS_UPLOADED: "Feltöltve",
  MY_DOCUMENTS_SIZE: "Méret",
  MY_DOCUMENTS_FILE_NAME: "Fájl név",
  MY_DOCUMENTS_EMPLOYEE_VISIBILITY: "Dolgozó láthatja",
  MY_DOCUMENTS_EMPLOYEE_UNVISIBILITY: "Dolgozó nem láthatja",
  MY_DOCUMENTS_DOCUMENTS: "Dokumentumok",
  MY_DOCUMENTS_MASS_UPLOAD: "Tömeges feltöltés",
  MY_DOCUMENTS_MASS_UPLOAD_TITLE: "Tömeges dokumentumfeltöltés",
  MY_DOCUMENTS_MASS_INSTRUCTIONS_TITLE: "Használati útmutató",
  MY_DOCUMENTS_MASS_INSTRUCTIONS_TEXT: "Töltsön fel egyszerre több dokumentumot különböző alkalmazottakhoz. A fájlnevekben adja meg az dolgozói törzsszámot (jogviszonykód).\nTámogatott formátumok: PDF, DOC, DOCX, XLS, XLSX, PNG, JPG, JPEG, GIF.\nMaximális fájlméret: 9MB.",
  MY_DOCUMENTS_MASS_FILENAME_FORMAT: "Fájlnév formátum: {jogviszonykod}_{leiras}.{kiterjesztes} (pl. 12345_munkaszerzodes.pdf)",
  MY_DOCUMENTS_MASS_DROP_TEXT: "Húzza ide a fájlokat vagy kattintson a tallózáshoz (max 50 fájl)",
  MY_DOCUMENTS_SELECTED_FILES: "Kiválasztott fájlok",
  MY_DOCUMENTS_REMOVE_ALL: "Összes törlése",
  MY_DOCUMENTS_NO_DESCRIPTION: "Nincs leírás",
  MY_DOCUMENTS_UPLOADING_FILES: "Fájlok feltöltése folyamatban",
  MY_DOCUMENTS_PROCESSING_FILES: "Fájlok feldolgozása...",
  MY_DOCUMENTS_SUCCESSFUL_UPLOADS: "Sikeres feltöltések",
  MY_DOCUMENTS_FAILED_UPLOADS: "Sikertelen feltöltések",
  MY_DOCUMENTS_UPLOAD_FILES: "Fájlok feltöltése",
  MY_DOCUMENTS_UNKNOWN_ERROR: "Ismeretlen hiba",
  MY_DOCUMENTS_ERROR_INVALID_FORMAT: "Érvénytelen fájlnév formátum (formátum: {jogviszonykod}_{leiras}.pdf)",
  MY_DOCUMENTS_ERROR_INVALID_LENGTH: "Az dolgozói törzsszám hossza nem megfelelő (pontosan 5 karakter szükséges)",
  MY_DOCUMENTS_ERROR_ID_NOT_FOUND: "Az dolgozói törzsszám nem található az adatbázisban",
  MY_DOCUMENTS_ERROR_UNSUPPORTED_TYPE: "Nem támogatott fájltípus",
  MY_DOCUMENTS_MASS_TOO_MANY_FILES: "Túl sok fájl (maximum 50 fájl engedélyezett)",
  MY_DOCUMENTS_MASS_NO_VALID_FILES: "Nincs érvényes fájl a feltöltéshez",
  MY_DOCUMENTS_MASS_UPLOAD_ALL_SUCCESS: "{{count}} fájl sikeresen feltöltve",
  MY_DOCUMENTS_MASS_UPLOAD_ALL_FAILED: "{{count}} fájl feltöltése sikertelen",
  MY_DOCUMENTS_MASS_UPLOAD_PARTIAL: "{{success}} fájl sikeres, {{failed}} sikertelen",
  MY_DOCUMENTS_MASS_UPLOAD_ERROR: "Hiba történt a feltöltés során",
  MY_DOCUMENTS_FAILED_FILES: "Sikertelen fájlok",
  MY_DOCUMENTS_MASS_UPLOAD_HISTORY: "Tömegesen feltöltött fájlok",
  MY_DOCUMENTS_UPLOADED_FILES: "Feltöltött fájlok",
  MY_DOCUMENTS_NO_FILES: "Nincs fájl",
  MY_DOCUMENTS_UPLOADED_AT: "Feltöltés dátuma",
  MY_DOCUMENTS_FILE_COUNT: "Fájlok száma",
  MY_DOCUMENTS_DELETE_MASS_UPLOAD_CONFIRM_INFO: "Valóban törli az összes feltöltött dokumentumot?",
};
